{
  "es": {
    "marketplace_partner": {
      "contact_me": {
        "success": "Nos pondremos en contacto contigo en breve.",
        "failure": "Se ha producido un error inesperado.",
        "button": "¡Contáctame!"
      }
    }
  }
}
